import { config } from '@/pageConfig/claims/de/de';
import { ClaimsPageTemplate } from '@/pageTemplate/ClaimsPageTemplate';

export default function ClaimsPage() {
  return <ClaimsPageTemplate config={config} />;
}
